<template>
    <div>
        <img v-if="flowPackageIcon" class="d11-entry" :src="flowPackageIcon" @click="handleEntryClick" />
        <div v-if="showClaimDialog" class="d11-shadow" @click.self="showClaimDialog = false">
            <div class="d11-claim-dialog">
                <img src="~@/assets/newHome/关闭.png" alt="" class="d11-dialog-close" @click="showClaimDialog = false" />
                <div class="d11-claim-title">双十一 限时活动</div>
                <div class="d11-claim-desc">机构企业用户可免费领取高级流量包10000 次</div>
                <div class="d11-claim-sub">（价值 1600 元）</div>
                <div class="d11-claim-buttons">
                    <div class="d11-btn-cancel" @click="showClaimDialog = false">暂不领取</div>
                    <div class="d11-btn-confirm" :class="{ 'd11-btn-claiming': claiming }" @click="handleClaim">立即领取</div>
                </div>
            </div>
        </div>
        <double11-success-dialog :visible="showSuccessDialog" @close="showSuccessDialog = false"></double11-success-dialog>
        <div v-if="d11ToastVisible" class="d11-toast">{{ d11ToastText }}</div>
    </div>
</template>

<script>
import { rootUrl } from '@/globalConfig'
import Double11SuccessDialog from './Double11SuccessDialog.vue'

export default {
    name: 'Double11Activity',
    components: { Double11SuccessDialog },
    data() {
        return {
            flowPackageIcon: '',
            showClaimDialog: false,
            showSuccessDialog: false,
            claiming: false,
            d11EntryChecked: false,
            d11ToastVisible: false,
            d11ToastText: '',
            d11ToastTimer: null
        }
    },
    watch: {
        '$store.state.user.logined': {
            handler: function (val) {
                if (val && !this.d11EntryChecked) {
                    this.d11EntryChecked = true
                    this.entryCheck()
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.fetchDisplayConfig()
    },
    beforeDestroy() {
        if (this.d11ToastTimer) clearTimeout(this.d11ToastTimer)
    },
    methods: {
        getKey() {
            return localStorage.getItem('token')
        },
        // 活动展示标识：flowPackageIcon 非空才显示入口按钮（接口无需登录）
        fetchDisplayConfig() {
            this.axios.get('/accessapi/requirement/getActivityDisplayConfig').then((res) => {
                if (res.data.status === 200) {
                    this.flowPackageIcon = res.data.data.flowPackageIcon || ''
                }
            }).catch((e) => { console.log(e) })
        },
        // 进首页自动检查：默认不弹，仅 claimed === true 时弹【领取成功】（会话级去重）
        entryCheck() {
            if (sessionStorage.getItem('double11SuccessAutoShown') === '1') return
            this.axios.get('/tileflowapi/flow/package/double11/check', {
                headers: { Authorization: 'Bearer ' + this.getKey() }
            }).then((res) => {
                if (res.data.code === 200 && res.data.data.claimed === true && sessionStorage.getItem('double11SuccessAutoShown') !== '1') {
                    sessionStorage.setItem('double11SuccessAutoShown', '1')
                    this.showSuccessDialog = true
                }
            }).catch((e) => { console.log(e) })
        },
        // 点击活动入口：未登录跳登录页；已登录按 check 分支处理
        handleEntryClick() {
            if (!localStorage.getItem('userId')) {
                window.open(rootUrl + '/Login?fromUrl=' + rootUrl + '/rskit', '_self')
                return
            }
            this.axios.get('/tileflowapi/flow/package/double11/check', {
                headers: { Authorization: 'Bearer ' + this.getKey() }
            }).then((res) => {
                if (res.data.code !== 200) {
                    this.$message.warning(res.data.msg || '请重新登录')
                    window.open(rootUrl + '/Login?fromUrl=' + rootUrl + '/rskit', '_self')
                    return
                }
                const data = res.data.data
                if (data.enterpriseCertified === false) {
                    this.goEnterpriseCert()
                } else if (data.activityDay === false) {
                    // 非活动期：已认证只 toast 提示 3 秒，不弹窗；未上传委托书的停留 3 秒后跳企业认证页
                    if (data.letterApproved === true) {
                        this.showD11Toast('活动仅限2026/11/11当天领取~')
                    } else {
                        this.showD11Toast('上传授权委托书，审核成功后即可领取~', this.goEnterpriseCert)
                    }
                } else if (data.letterApproved === false) {
                    // 活动期：委托书未过审，toast 停留 3 秒后跳企业认证页
                    this.showD11Toast('上传授权委托书，审核成功后即可领取~', this.goEnterpriseCert)
                } else if (data.claimed === true) {
                    this.showSuccessDialog = true
                } else {
                    this.showClaimDialog = true
                }
            }).catch((e) => {
                console.log(e)
                this.$message.error('网络异常，请稍后重试')
            })
        },
        // 立即领取：claim 结果按 data.code 分支
        handleClaim() {
            if (this.claiming) return
            this.claiming = true
            this.axios.post('/tileflowapi/flow/package/double11/claim', null, {
                headers: { Authorization: 'Bearer ' + this.getKey() }
            }).then((res) => {
                this.claiming = false
                if (res.data.code !== 200) {
                    this.$message.warning(res.data.msg || '操作失败，请稍后重试')
                    return
                }
                const code = res.data.data.code
                if (code === 'SUCCESS' || code === 'ALREADY_CLAIMED') {
                    this.showClaimDialog = false
                    this.showSuccessDialog = true
                } else if (code === 'CLAIM_FAILED') {
                    this.showClaimDialog = false
                    this.showD11Toast('上传授权委托书，审核成功后即可领取~', this.goEnterpriseCert)
                } else if (code === 'ACTIVITY_ENDED') {
                    this.showClaimDialog = false
                    this.$message.warning('活动已结束')
                } else {
                    this.$message.warning(res.data.msg || '操作失败，请稍后重试')
                }
            }).catch((e) => {
                console.log(e)
                this.claiming = false
                this.$message.error('网络异常，请稍后重试')
            })
        },
        // 双11提示 toast：红色底白色字 18px 顶部居中，停留 3 秒自动关闭；jump 传入则停留 3 秒后跳转
        showD11Toast(text, jump) {
            this.d11ToastText = text
            this.d11ToastVisible = true
            if (this.d11ToastTimer) clearTimeout(this.d11ToastTimer)
            this.d11ToastTimer = setTimeout(() => {
                this.d11ToastVisible = false
            }, 3000)
            if (jump) {
                setTimeout(jump, 3000)
            }
        },
        goEnterpriseCert() {
            window.open(rootUrl + '/store/ApplyGovernmentMember?fromUrl=' + rootUrl + '/rskit', '_self')
        }
    }
}
</script>

<style scoped>
.d11-entry {
    position: fixed;
    right: 20px;
    bottom: calc(50% + 140px);
    width: 116px;
    z-index: 11000;
    cursor: pointer;
}
.d11-shadow {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 12000;
}
.d11-claim-dialog {
    position: absolute;
    width: 516px;
    height: auto;
    padding: 44px 40px 36px;
    border-radius: 8px;
    left: calc(50% - 258px);
    top: calc(50% - 155px);
    z-index: 12001;
    background: #ffffff;
    box-sizing: border-box;
}
.d11-dialog-close {
    position: absolute;
    top: 0;
    right: -50px;
    cursor: pointer;
}
.d11-claim-title {
    width: 100%;
    height: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #1F1F1F;
    line-height: 30px;
    text-align: center;
}
.d11-claim-desc {
    width: 100%;
    margin-top: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 26px;
    text-align: center;
}
.d11-claim-sub {
    width: 100%;
    margin-top: 6px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #8C8C8C;
    line-height: 24px;
    text-align: center;
}
.d11-claim-buttons {
    width: 100%;
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 60px;
}
.d11-btn-cancel {
    width: 120px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
    background: #ffffff;
}
.d11-btn-cancel:hover {
    border-color: #40A9FF;
    color: #40A9FF;
}
.d11-btn-confirm {
    width: 120px;
    height: 36px;
    border-radius: 4px;
    background: #1890FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.d11-btn-confirm:hover {
    background: #40A9FF;
}
.d11-btn-claiming {
    opacity: 0.6;
    pointer-events: none;
}
.d11-toast {
    position: fixed;
    top: 90px;
    left: 50%;
    transform: translateX(-50%);
    background: #F5222D;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    padding: 12px 24px;
    border-radius: 6px;
    z-index: 13000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
</style>
